import { render } from "./TourManager.vue?vue&type=template&id=e636703c"
import script from "./TourManager.vue?vue&type=script&lang=js"
export * from "./TourManager.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__